<template>
  <div class="classes">
    <!-- <van-nav-bar title="班级考勤" /> -->
    <van-tabs color="#1989fa" background="none" @change="handleChangeTab">
      <van-tab
        v-for="item in columns"
        :title="item.className"
        :name="item.id"
        :key="item.id"
      ></van-tab>
    </van-tabs>
    <!-- <div class="screen">
      <div class="screen-wrap" @click="showPicker = true">
        <div>班级 {{ classes }}</div>
        <span class="iconfont">&#xe607;</span>
      </div>
    </div>
    <div class="screen">
      <div class="screen-wrap" @click="$refs.starttime.showTimePopup = true">
        <div>选择时间 {{ date }}</div>
        <span class="iconfont">&#xe607;</span>
      </div>
    </div> -->
    <div class="wrap">
      <!-- <div class="chart">
        <canvas id="container"></canvas>
      </div>
      <div class="feature">
        <div>
          {{
            this.classesOneData.length > 0
              ? this.classesOneData[0].normalNumber
              : ''
          }}
          /
          {{
            this.classesOneData.length > 0
              ? this.classesOneData[0].classNumber
              : ''
          }}
          实到 / 应到
        </div>
      </div> -->
      <div class="filter">
        <!-- <div class="feature flex flex-b" @click="showPicker = true">
        <div class="date">{{ classes }}</div>
        <div class="control">
          选择班级
        </div>
      </div> -->
        <div
          class="feature flex flex-b"
          @click="$refs.starttime.showTimePopup = true"
        >
          <div class="date">{{ date }}</div>
          <div class="control">
            选择时间
          </div>
        </div>
      </div>
      <div class="info">
        <div class="info-item">
          <div class="info-count">
            <span>{{ data && data.classNumber }}</span>
            <span class="unit">人</span>
          </div>
          <div class="info-name">应到</div>
        </div>
        <div class="info-item">
          <div class="info-count">
            <span>{{ data && data.normalNumber }}</span>
            <span class="unit">人</span>
          </div>
          <div class="info-name">实到</div>
        </div>
        <div class="info-item">
          <div class="info-count">
            <span>{{ data && data.leaveNumber }}</span>
            <span class="unit">人</span>
          </div>
          <div class="info-name">请假</div>
        </div>
        <div class="info-item">
          <div class="info-count">
            <span>{{ data && data.lateNumber }}</span>
            <span class="unit">人</span>
          </div>
          <div class="info-name">迟到</div>
        </div>
      </div>
      <!-- <div class="list">
        <van-collapse v-model="activeNames">
          <van-collapse-item
            :title="item.name"
            :name="index"
            size="large"
            v-for="(item, index) in coList"
            :key="index"
          >
            <div v-for="v in item.list" style="padding: 0.5rem 1rem;">
              {{ v.userName }}
            </div>
          </van-collapse-item>
        </van-collapse>
      </div> -->
      <div class="list-table">
        <div class="list-table-title">
          出勤详情
        </div>
        <div class="list-table-thead">
          <div class="table-1 flex-1">姓名</div>
          <div class="table-3 flex-2">
            <div class="top">上午</div>
            <div class="flex status"><span>到校</span><span>离校</span></div>
          </div>
          <div class="table-3 flex-2">
            <div class="top">下午</div>
            <div class="flex status"><span>到校</span><span>离校</span></div>
          </div>
        </div>
        <div class="list-table-body ">
          <div
            class="flex list-table-item "
            v-for="(item, index) in data && data.studentClocksDTOList"
            :key="index"
          >
            <div class="table-1 flex-1">
              <span class="mark blue" :class="getCheckState(item)"></span>
              <span>{{ item.userName }}</span>
            </div>
            <div class="table-3 flex-2 flex">
              <span
                class="flex-1"
                :class="[
                  {
                    orange: item.amFirstClockState == -1,
                  },
                ]"
                >{{ item.amFirstClockTime }}</span
              >
              <span
                class="flex-1"
                :class="[
                  {
                    orange: item.amLastClockState == -2,
                  },
                ]"
                >{{ item.amLastClockTime }}</span
              >
            </div>
            <div class="table-3 flex-2 flex">
              <span
                class="flex-1"
                :class="[
                  {
                    orange: item.pmFirstClockState == -1,
                  },
                ]"
                >{{ item.pmFirstClockTime }}</span
              >
              <span
                class="flex-1"
                :class="[
                  {
                    orange: item.pmLastClockState == -2,
                  },
                ]"
                >{{ item.pmLastClockTime }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="minDate"
      :maxDate="new Date()"
      type="date"
      :currentDate="startMinTime"
    />
    <!-- 选择班级 -->
    <!-- <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup> -->
    <!-- 筛选弹窗 -->
    <!-- <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="screen-wrap-popup">
        <div class="screen-title">
          条件筛选
        </div>
        <van-row class="screenwrap">
          <van-col :span="6"><div class="left">选择时间</div></van-col>
          <van-col :span="18"
            ><div
              class="input-content"
              @click="$refs.starttime.showTimePopup = true"
            >
              {{ date }}
            </div></van-col
          >
        </van-row>
        <van-row class="screenwrap">
          <van-col :span="6"><div class="left">选择班级</div></van-col>
          <van-col :span="18"
            ><div class="input-content" @click="showPicker = true">
              {{ classes }}
            </div></van-col
          >
        </van-row>
        <van-row :gutter="20" style="margin-top: 10px;">
          <van-col :span="12"><van-button block>取消</van-button></van-col>
          <van-col :span="12"
            ><van-button type="info" block @click="handleConfirm"
              >确定</van-button
            ></van-col
          >
        </van-row>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import F2 from '@antv/f2/lib/index-all'
import SelectTime from '@/components/subScribePopup/selectTime'
import moment from 'moment'
export default {
  data() {
    return {
      showDate: false,
      date: moment().format('YYYY-MM-DD'),
      minDate: new Date(2020, 1, 1),
      startMinTime: new Date(moment().format('YYYY-MM-DD')),
      activeNames: [0, 1, 2, 3, 4, 5, 6],
      showPicker: false,
      columns: [],
      classes: '',
      // classesAllData: [],
      // chartData: [],
      show: false,
      classesOneData: [],
      coList: [],
      classId: '',
      data: {},
    }
  },
  components: {
    SelectTime,
  },
  mounted() {
    // this.getClassesAttendance(true)
    this.getClassListByTeacherId()
  },
  methods: {
    getCheckState(item) {
      if (
        !item.amFirstClockState ||
        !item.amLastClockState ||
        !item.pmFirstClockState ||
        !item.pmLastClockState
      ) {
        return 'red'
      }
      if (
        item.amFirstClockState == '-1' ||
        item.amLastClockState == '-2' ||
        item.pmFirstClockState == '-1' ||
        item.pmLastClockState == '-2'
      ) {
        return 'orange'
      }
      return 'blue'
    },
    handleTimeStartConfirm(val) {
      this.date = val
      this.getStudentDataByClassIdAndDate()
    },

    async getClassListByTeacherId() {
      const { data, code } = await this.$https.getClassListByTeacherId({
        teacherId: this.$store.state.userId,
      })
      if (code !== 200) {
        return false
      }
      if (data[0].id) {
        this.classId = data[0].id
        this.getStudentDataByClassIdAndDate()
      } else {
        this.$toast('您不是班主任，无权限查看')
      }
      this.columns = data
    },
    handleChangeTab(id) {
      this.classId = id
      this.getStudentDataByClassIdAndDate()
    },
    async getStudentDataByClassIdAndDate() {
      const { data, code } = await this.$https.getStudentDataByClassIdAndDate({
        classId: this.classId,
        schoolId: this.$store.state.schoolId,
        toDay: this.date,
      })
      if (code !== 200) {
        return false
      }
      this.data = data[0]
    },
    // onConfirm(val) {
    //   // console.log(val)
    //   this.classes = val
    //   this.showPicker = false
    //   this.getClassesAttendance()

    //   // this.$nextTick(() => {
    //   // this.renderChart()
    //   // })
    // },
    // handleConfirm() {
    //   this.getClassesAttendance()
    //   this.show = false
    // },
    // async getClassesAttendance(status) {
    //   const { data, code } = await this.$https.getClassesAttendance({
    //     userId: this.$store.state.userId,
    //     toDay: this.date,
    //   })
    //   if (code !== 200) {
    //     return false
    //   }
    //   // 取数据第一项，作为默认值
    //   if (status) {
    //     this.classes = data[0].className
    //   }
    //   // 班级集合
    //   this.columns = data.map((item) => item.className)
    //   // 出当前默认班级的数据
    //   this.classesOneData = data.filter(
    //     (item) => item.className == this.classes
    //   )
    //   // 过滤掉为空的数据
    //   this.coList = this.renderListData(this.classesOneData[0]).filter(
    //     (item) => item.list.length > 0
    //   )
    //   // 渲染图表
    //   // const chartData = this.renderChartData(this.classesOneData[0])
    //   // this.$nextTick(() => {
    //   //   this.renderChart(chartData)
    //   // })
    // },
    // renderListData(listdata) {
    //   const {
    //     listAbsence,
    //     listEarly,
    //     listLate,
    //     listLeave,
    //     listNormal,
    //   } = listdata
    //   const data = [
    //     {
    //       name:
    //         this.date == moment().format('YYYY-MM-DD') ? '未打卡' : '缺勤人员',
    //       list: listAbsence,
    //     },
    //     {
    //       name: '早退人员',
    //       list: listEarly,
    //     },
    //     {
    //       name: '迟到人员',
    //       list: listLate,
    //     },
    //     {
    //       name: '请假人员',
    //       list: listLeave,
    //     },
    //     {
    //       name: '出勤人员',
    //       list: listNormal,
    //     },
    //   ]
    //   return data
    // },
    // renderChartData(data) {
    //   const {
    //     lateNumber,
    //     normalNumber,
    //     absenceNumber,
    //     leaveNumber,
    //     earlyNumber,
    //   } = data
    //   const chatData = [
    //     {
    //       const: 'const',
    //       type: '迟到',
    //       money: lateNumber,
    //     },
    //     // {
    //     //   const: 'const',
    //     //   type: '正常',
    //     //   money: normalNumber,
    //     // },
    //     {
    //       const: 'const',
    //       type: this.date == moment().format('YYYY-MM-DD') ? '未打卡' : '缺勤',
    //       money: absenceNumber,
    //     },
    //     {
    //       const: 'const',
    //       type: '请假',
    //       money: leaveNumber,
    //     },
    //     {
    //       const: 'const',
    //       type: '早退',
    //       money: earlyNumber,
    //     },
    //   ]
    //   return chatData
    // },
    // renderChart(data) {
    //   const cw = document.querySelector('.chart').clientWidth
    //   const chart = new F2.Chart({
    //     id: 'container',
    //     pixelRatio: window.devicePixelRatio,
    //     width: cw,
    //     height: 300,
    //   })
    //   chart.source(data)
    //   chart.coord('polar', {
    //     transposed: true,
    //     radius: 0.9,
    //     innerRadius: 0.7,
    //   })
    //   chart.axis(false)
    //   chart.legend(false)
    //   chart.tooltip(false)
    //   // chart.guide().html({
    //   //   position: ['50%', '50%'],
    //   //   html: `<div style="width: 250px;height: 40px;text-align: center;">
    //   //     <div style="font-size: 1.4rem;font-size:blod;"><span style="color:red"></span>/ <span></span></div>
    //   //     <div style="font-size: 0.65rem;margin-top:0.5rem">实到 / 应到</div>
    //   //   </div>`,
    //   // })

    //   chart
    //     .interval()
    //     .position('const*money')
    //     .adjust('stack')
    //     .color('type', [
    //       '#1890FF',
    //       '#13C2C2',
    //       '#2FC25B',
    //       '#FACC14',
    //       '#F04864',
    //       '#8543E0',
    //       '#3436C7',
    //       '#223273',
    //     ])
    //   chart.pieLabel({
    //     sidePadding: 30,
    //     activeShape: false,
    //     label1: function label1(data) {
    //       return {
    //         text: data.money + '人',
    //         fill: '#343434',
    //         fontWeight: 'bold',
    //       }
    //     },
    //     label2: function label2(data) {
    //       return {
    //         text: data.type,
    //         fill: '#999',
    //       }
    //     },
    //   })
    //   chart.render()
    // },
  },
}
</script>

<style lang="scss" scoped>
.screen {
  /* padding: 1rem 1rem 0; */
  margin-bottom: 1rem;
  .screen-wrap {
    background: #fff;
    padding: 0.8rem 1rem;
    border-radius: 0.75rem;
    color: #999;
    font-size: 0.85rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 0.75rem;
    }
  }
}
.classes {
  /* margin: 1rem; */
  /* border-radius: 0.85rem; */
  padding-bottom: 50px;

  .wrap {
    border-radius: 0.85rem;
    overflow: hidden;
    padding: 1rem 0.5rem;
    .info {
      display: flex;
      background: #fff;
      box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08);
      border-radius: 1rem;
      padding: 1rem 0;
      margin-top: 1rem;
      justify-content: center;
      .info-item {
        flex: 1;
        text-align: center;
        border-right: 0.06rem solid #f4f4f6;
        &:last-child {
          border-right: none;
        }
        .info-count {
          font-size: 1.25rem;

          color: #454f63;
          .unit {
            font-size: 0.69rem;
            color: #78849e;
            margin-left: 0.4rem;
          }
        }
        .info-name {
          color: #78849e;
          font-size: 0.69rem;
          margin-top: 0.3rem;
        }
      }
    }
    .list-table {
      background: #fff;
      border-radius: 1rem;
      margin-top: 1rem;
      box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08);

      .list-table-title {
        font-size: 0.88rem;
        color: #78849e;
        padding: 1rem;
      }
      .list-table-thead {
        display: flex;
        padding: 1rem 0;
        margin: 0 1rem;
        border-top: 0.06rem solid #f4f4f6;
        border-bottom: 0.06rem solid #f4f4f6;
        align-items: center;
        text-align: center;

        color: #78849e;
        font-size: 0.75rem;
        .table-1 {
          border-right: 0.06rem solid #f4f4f6;
          padding: 0.8rem 0;
        }
        .table-3 {
          border-right: 0.06rem solid #f4f4f6;

          .top {
            margin: 0 0.8rem;

            padding: 0.3rem 0;
            border-bottom: 0.06rem solid #f4f4f6;
          }
          .status {
            padding: 0.3rem 0;
            span {
              flex: 1;
            }
          }
        }
      }
      .list-table-body {
        margin: 0 1rem;
        .list-table-item {
          border-bottom: 0.06rem solid #f4f4f6;
          padding: 1rem 0;
          align-items: center;
          .table-1 {
            color: #454f63;
            font-size: 0.75rem;
            .mark {
              display: inline-block;
              width: 0.63rem;
              height: 0.63rem;
              border-radius: 0.19rem;
              margin-right: 0.3rem;
              &.blue {
                background: #3497fd;
              }
              &.orange {
                background: #ff9057;
              }
              &.red {
                background: #ff5e84;
              }
            }
          }
          .table-3 {
            opacity: 0.98;
            color: #78849e;
            font-size: 0.75rem;
            text-align: center;
            .blue {
              color: #3497fd;
            }
            .orange {
              color: #ff9057;
            }
            .red {
              color: #ff5e84;
            }
          }
        }
      }
    }
  }
  .filter {
    border-radius: 0.75rem;
    box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08);
    background: #fff;

    .feature {
      padding: 0.85rem;
      color: #999;
      font-size: 0.75rem;
    }
  }

  .title {
    background: #fff;
    font-size: 0.85rem;
    padding: 0.5rem 0.85rem;
    border-bottom: 1px solid #f4f4f6;
    color: #999;
  }
  .chart {
    background: #fff;
  }
  .list {
    overflow: hidden;
    margin-top: 1rem;
    border-radius: 1rem;
  }
}
.screen-wrap-popup {
  padding: 20px;
  .screenwrap {
    padding: 1rem;
    .left {
      /* display; */
      /* padding: 0.7rem 0; */
      font-size: 0.8rem;
      vertical-align: middle;
      height: 2.3rem;
      line-height: 2.3rem;
    }
    .input-content {
      background: #f4f4f6;
      padding: 0rem 1rem;
      border-radius: 2rem;
      height: 2.3rem;
      line-height: 2.3rem;
    }
  }
  .screen-title {
    text-align: center;
    color: #999;
    font-size: 1rem;
  }
}
</style>
